export const serviceCityColumns = [
  {
    name: "Name",
    selector: (row) => row["name"],
    sortable: true,
    center: true,
  },
  {
    name: "City Code",
    selector: (row) => row["cityCode"],
    sortable: true,
    center: true,
  },
  {
    name: "Aggregator Name",
    selector: (row) => row["aggregatorName"],
    sortable: true,
    center: true,
  },
  {
    name: "Company Name",
    selector: (row) => row["companyName"],
    sortable: true,
    center: true,
  },
  {
    name: "Place of Supply",
    selector: (row) => row["placeOfSupply"],
    sortable: true,
    center: true,
  },
  {
    name: "",
    cell: (row) => row["action"],
    sortable: true,
    center: true,
    width: "30px",
  },
];
